const dictionary: any = {
  ['custom-filtering']: 1,
  ['price-range']: 2,
  ['hot-brand']: 3,
  ['category']: 4
};

const getValueByKey = (key: string) => {
  return dictionary[key];
};

export default { dictionary, getValueByKey };